module.exports = {"data":{"contributionsJson":{"name":"old school","www_url":"","thema":"neue kunstschule","issue_month":"May","issue_year":2005,"issue_date":200505,"artist":"","location":"","email":"","id":"contribution_98","media_type":"still_image","position_in_section":4,"media_uri":"media/2005/May/photography/i-love-u.jpg","media_th_uri":"media/2005/May/photography/tn_i-love-u.jpg","still_image_count":5,"moving_image_count":1,"textz_count":0,"soundz_count":0}},"pathContext":{"id":"contribution_98"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/issue-200505-still-image-4.json
// module id = 766
// module chunks = 159920260028297